import { QueryClient } from "@tanstack/react-query"

const staleTime = 1000 * 30 // 30 seconds

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: staleTime,
			refetchOnWindowFocus: true,
			refetchOnMount: true,
			refetchIntervalInBackground: true,
			refetchOnReconnect: true,
			retry: true,
			retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
		},
	},
})
